const isPrerender =
  typeof navigator !== 'undefined' &&
  typeof navigator.userAgent === 'string' &&
  navigator.userAgent.toLowerCase().includes('reactsnap');

// Avoid loading the real Mixpanel client while prerendering (e.g., react-snap).
// The library spins up proxies that rely on browser APIs and can throw during prerender.
// In that case, fall back to a no-op client to keep the render stable.
let mixpanelClient;

if (isPrerender) {
  const noop = () => {};
  mixpanelClient = {
    init: noop,
    reset: noop,
    track: noop,
    identify: noop,
    people: {
      set: noop,
      set_once: noop,
    },
    register_once: noop,
    register: noop,
  };
} else {
  // eslint-disable-next-line global-require
  mixpanelClient = require('mixpanel-browser');
}

export default mixpanelClient;
